import { modelosDocumentoService } from '@/features/modelos-documento/api';
import type { ListarModelosDecursoArgs } from '../../types/modelosDecurso';
import { modelosDecursoPageSize } from '../../utils/modelosDecursoConstants';
export const modelosDecursoService = {
  listar: ({ page, categorias }: ListarModelosDecursoArgs) =>
    modelosDocumentoService.list({
      categorias,
      apenasAtivos: true,
      page,
      pageSize: modelosDecursoPageSize,
    }),
};
